import React, { FC, useState } from 'react'
import {
  Button,
  HStack,
  Image,
  Square,
  Text,
  VStack,
  Checkbox,
  Box,
  useBoolean
} from '@chakra-ui/react'
import { useHistory } from 'react-router'
import moment from 'moment'
import Datetime from 'react-datetime'
import { Layout } from '../../../components'
import { ROUTES } from '../../../contants'
import useMotorStore from '../../../state/Motor.store'
import { screens } from './types'

const MotorDetails = () => {
  const [vehicleDetails, setScreen] = useMotorStore((state) => [
    state.vehicleDetails,
    state.setScreen
  ])
  const [accepted, setAccepted] = useBoolean()

  return (
    <Layout previous={() => setScreen(screens.ENTER_PLATE)} title="Vehicle Details">
      <Box flex={1}>
        <Text fontSize="1.2rem">Please confirm your vehicle details before proceeding.</Text>
        <Image my="3.2rem" mx="auto" maxW="261px" src="/images/car.png" />
        <VStack justify="flex-start" align="flex-start" spacing="1rem">
          <Detail
            image="brand"
            title="Brand/Model"
            body={`${vehicleDetails.make} / ${vehicleDetails.model}`}
          />
          <Detail image="chassis" title="Chassis No." body={vehicleDetails.chasis_number} />
          <HStack w="full" spacing="1rem">
            <YearDetail image="year" title="Year" />
            <Detail
              image="plate"
              title="Vehicle Plate Number"
              body={vehicleDetails.plate_number.toUpperCase()}
            />
          </HStack>
        </VStack>
      </Box>
      <Checkbox onChange={setAccepted.toggle} my="2.4rem" size="lg">
        I acknowledge that the information displayed above is accurate and up-to-date at this time
      </Checkbox>
      <Button disabled={!accepted} onClick={() => setScreen(screens.MOTOR_POLICY)} variant="blue">
        Confirm Details
      </Button>
    </Layout>
  )
}

export { MotorDetails }

type Props = {
  image: string
  title: string
  body: string
}
const Detail: FC<Props> = ({ image, title, body }) => {
  return (
    <HStack
      w="100%"
      boxShadow="0px 4px 12px rgba(154, 160, 166, 0.04)"
      borderRadius="1.2rem"
      p="0.8rem"
      bg="white">
      <Square mr="1.2rem" size="4rem" bg="#F7F7F7">
        <Image src={`/images/${image}.svg`} />
      </Square>
      <VStack align="flex-start">
        <Text fontSize="1rem">{title}</Text>
        <Text color="black" fontWeight="500" fontSize="1.2rem">
          {body}
        </Text>
      </VStack>
    </HStack>
  )
}

const YearDetail: FC<{ image: string; title: string }> = ({ image, title }) => {
  const [vehicleDetails, setYear] = useMotorStore((state) => [state.vehicleDetails, state.setYear])
  return (
    <HStack
      w="100%"
      boxShadow="0px 4px 12px rgba(154, 160, 166, 0.04)"
      borderRadius="1.2rem"
      p="0.8rem"
      bg="white">
      <Square mr="1.2rem" size="4rem" bg="#F7F7F7">
        <Image src={`/images/${image}.svg`} />
      </Square>
      <VStack align="flex-start">
        <Text fontSize="1rem">{title}</Text>
        <Datetime
          className="custom-rdt"
          onChange={(date) => setYear(moment(date).format('YYYY'))}
          value={vehicleDetails.year}
          closeOnSelect
          timeFormat={false}
          dateFormat="YYYY"
          inputProps={inputProps}
        />
      </VStack>
    </HStack>
  )
}

const inputProps = {
  placeholder: 'Select Year',
  autoComplete: 'off',
  readOnly: true
}
